/* eslint-disable no-restricted-syntax */
import React, { PureComponent } from 'react'
import OrderQuote, { ErrorOrderQuote } from 'requests/objects/order-quote'
import Status from 'types/status'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import Loader from 'components/visuals/loader'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import { NEW_PATH } from 'types/others'
import { tKey, tObj } from 'helpers/methods/translate'
import history from 'helpers/history'
import styles from 'styles/pages/order-quotes/[id].module.scss'
import CreationStep from 'components/pages/order-quotes/[id]/creationStep'
import EWorkflowStep from 'types/orders/enums/workflowStep'
import parseJson from 'helpers/methods/parseJson'
import MaintenancePortalInfo from 'components/pages/maintenancePortalInfo'
import ConfirmationStep from 'components/pages/order-quotes/[id]/confirmationStep'
import Merchandise from 'requests/objects/merchandise'
import { MessageBarType } from '@fluentui/react'
import RefuseReasonOrderQuoteInput from 'components/inputs/refuseReasonOrderQuoteInput'
import ConfirmationModal from 'components/modals/confirmation-modal'
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid'
/** @debug {import('app').AppProps} */

/**
 * @augments {PureComponent<import('app').AppProps>}
 */
export default class IdClientOrderQuotes extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {OrderQuote} Element find from API */
            item: new OrderQuote(),
            /** @type {OrderQuote} Element find from API */
            initItem: new OrderQuote(),
            /** @type {ErrorOrderQuote} Errors */
            errorField: new ErrorOrderQuote(),
            /** Current page index */
            currentPageIndex: 0,
            isExpirationModalVisible: false,
            expirationDate: null,
        }

        this.submitInput = React.createRef()
        this.validateOrderQuote = this.validateOrderQuote.bind(this)
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        const { setMessageBar } = this.props
        setMessageBar({ isDisplayed: false })
        this.init()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     */
    componentDidUpdate(prevProps, prevState) {
        const {
            match, lang,
        } = this.props

        const { currentPageIndex } = this.state

        if (match?.params?.orderQuoteId !== prevProps?.match?.params?.orderQuoteId)
            if (!prevProps?.match.path.includes(`/${NEW_PATH}`)) {
                this.init()
            } else {
                this.setupBreadcrumb()
                this.setupCommandBar()
            }

        if (lang !== prevProps.lang) {
            this.setupBreadcrumb()
            this.setupCommandBar()
        }

        if (currentPageIndex !== prevState.currentPageIndex)
            this.setupCommandBar()
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.orderQuotesHandlerGetById?.cancel()
        this.orderQuotesHandlerUpsert?.cancel()
        this.orderQuotesHandlerValidate?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb } = this.props
        const { item } = this.state

        const breadCrumb = [
            { text: this.tKey('myOrderQuotes'), key: 'all-quote', href: '/order-quotes' },
            {
                text: `${this.tKey('orderQuote')}${item.orderQuoteNumber ? ` n°${item.orderQuoteNumber}` : ''}`,
                key: 'one-order-quote',
                isCurrentItem: true,
            },
        ]

        setBreadcrumb(breadCrumb)
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const {
            setCommand, me: { isClient }, setModal,
        } = this.props
        const {
            currentPageIndex,
            initItem,
            status,
            item,
        } = this.state
        setCommand([])

        const isReadOnly = item.workflowHistorics?.some(
            x => x.workflowStepId === EWorkflowStep.QuoteRequest && !x.isActive,
        )

        /**
         * @type {import('@fluentui/react').ICommandBarItemProps[]} Commanbar items when readonly
         */
        /**
         * @type {import('@fluentui/react').ICommandBarItemProps[]} Commandbar items when readonly
         */
        this.commandRead = []

        // if (
        //     item.currentWorkflowStepId === EWorkflowStep.QuoteRequest
        //     && isClient
        //     && status !== Status.PENDING
        // )
        //     this.commandRead.push({
        //         key: 'edit',
        //         text: this.tKey('edit'),
        //         iconProps: { iconName: 'Edit' },
        //         onClick: () => this.setState(
        //             { currentPageIndex: 0 },
        //             () => setCommand(this.commandEdit),
        //         ),
        //     })

        switch (item.currentWorkflowStepId) {
            case EWorkflowStep.QuoteRequest:
                if (isClient) {
                    if (status !== Status.PENDING)
                        this.commandRead.push({
                            key: 'edit',
                            text: this.tKey('edit'),
                            iconProps: { iconName: 'Edit' },
                            onClick: () => this.setState(
                                { currentPageIndex: 0 },
                                () => setCommand(this.commandEdit),
                            ),
                        })
                    this.commandRead.push({
                        key: 'confirm order quote',
                        text: this.tKey('confirmOrderQuote'),
                        iconProps: { iconName: 'CheckMark' },
                        onClick: () => {
                            setModal({
                                show: true,
                                title: this.tKey('confirmOrderQuote'),
                                content: this.tKey('confirmOrderQuoteWarning'),
                                callback: () => this.validateOrderQuote({ isValidated: true }),
                                subTitle: this.tKey('confirmOrderQuoteConfirmation'),
                            })
                        },
                    })
                }

                break
            case EWorkflowStep.QuoteConfirmation:
                if (!isClient)
                    break
                this.commandRead.push({
                    key: 'accept order quote',
                    text: this.tKey('acceptOrderQuote'),
                    iconProps: { iconName: 'CheckMark' },
                    onClick: () => {
                        setModal({
                            show: true,
                            title: this.tKey('acceptOrderQuote'),
                            content: this.tKey('acceptOrderQuoteWarning'),
                            callback: () => this.validateOrderQuote({ isValidated: true }),
                            subTitle: this.tKey('acceptOrderQuoteConfirmation'),
                        })
                    },
                })
                this.commandRead.push({
                    key: 'cancel order quote',
                    text: this.tKey('refuseOrderQuote'),
                    iconProps: { iconName: 'Cancel' },
                    onClick: () => {
                        let currentReason = ''
                        let hasError = false

                        const openModal = () => {
                            const MaxRefuseReasonLength = 500

                            const remaining = MaxRefuseReasonLength - currentReason.length
                            setModal({
                                show: true,
                                title: this.tKey('refuseOrderQuote'),
                                subTitle: this.tKey('refuseOrderQuoteConfirmation'),
                                content: (
                                    <RefuseReasonOrderQuoteInput
                                        label={this.tKey('refusalReasonRequestOrderQuote')}
                                        value={currentReason}
                                        maxLength={MaxRefuseReasonLength}
                                        remaining={remaining}
                                        remainingText={this.tKey(
                                            remaining === 1
                                                ? 'charRemainingOne'
                                                : 'charRemainingOther',
                                            { count: remaining },
                                        )}
                                        errorMessage={hasError ? this.tKey('refusalReasonRequired') : null}
                                        onChange={value => {
                                            currentReason = value
                                            hasError = false
                                            openModal()
                                        }}

                                    />
                                ),
                                // eslint-disable-next-line consistent-return
                                callback: () => {
                                    if (!currentReason.trim()) {
                                        hasError = true
                                        openModal()
                                        return false
                                    }

                                    this.validateOrderQuote({
                                        isValidated: false,
                                        refuseReason: currentReason,
                                    })
                                },
                            })
                        }

                        openModal()
                    },
                })

                break
            case EWorkflowStep.QuoteCosting:
                if (isClient)
                    break
                if (!item.orderQuotePricings || item.orderQuotePricings.length === 0)
                    break
                this.commandRead.push({
                    key: 'validate the estimate',
                    text: this.tKey('sendCostingOrderQuote'),
                    iconProps: { iconName: 'CheckMark' },
                    onClick: () => {
                        this.setState({ isExpirationModalVisible: true })
                    },
                })
                break
            case EWorkflowStep.QuoteRefused:
                if (isClient)
                    break
                // eslint-disable-next-line no-case-declarations
                const refusedIsClosed = item.currentWorkflow?.workflowStepId === EWorkflowStep.QuoteRefused
                    && item.currentWorkflow?.isCompleted === true
                    && item.currentWorkflow?.isActive === false
                if (refusedIsClosed)
                    break

                this.commandRead.push({
                    key: 'counter quote',
                    text: this.tKey('counterOffer'),
                    iconProps: { iconName: 'CheckMark' },
                    onClick: () => {
                        setModal({
                            show: true,
                            title: this.tKey('counterOffer'),
                            content: this.tKey('counterOfferOrderQuoteInfo'),
                            callback: () => this.validateOrderQuote({ action: 'COUNTER_PROPOSAL' }),
                            subTitle: this.tKey('counterOfferOrderQuoteConfirmation'),
                        })
                    },
                })
                this.commandRead.push({
                    key: 'close quote',
                    text: this.tKey('closeOrderQuote'),
                    iconProps: { iconName: 'Cancel' },
                    onClick: () => {
                        setModal({
                            show: true,
                            title: this.tKey('closeOrderQuote'),
                            content: this.tKey('closeOrderQuoteInfo'),
                            callback: () => this.validateOrderQuote({ action: 'CLOSE_QUOTE' }),
                            subTitle: this.tKey('closeOrderQuoteConfirmation'),
                        })
                    },
                })
                break
            default:
                break
        }

        /**
         * @type {import('@fluentui/react').ICommandBarItemProps[]} Commanbar items when editing
         */
        this.commandEdit = [
            {
                key: 'cancel',
                text: this.tKey('cancel'),
                iconProps: { iconName: 'Cancel' },
                onClick: () => {
                    if (initItem.orderQuoteId)
                        this.setState({ currentPageIndex: 2, item: initItem })

                    else
                        history.push('/order-quotes')
                },
            },
            ...(!isReadOnly ? [{
                key: 'save',
                text: this.tKey('save'),
                iconProps: { iconName: 'Save' },
                onClick: () => {
                    this.submitInput.current.click()
                },
            }] : []),
        ]

        if (currentPageIndex === 0)
            setCommand(this.commandEdit)
        else
            setCommand(this.commandRead)
    }

    // /**
    //  * Confirmation modal
    //  * @returns {JSX.Element} Element
    //  */
    // modalConfirmation() {
    //     const { item } = this.state

    //     return (
    //         <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
    //             <span>
    //                 {this.tKey('validationOfTheCommercialProposal', {
    //                     price: formatPrice(OrderQuote.getTotal(item.orderQuotePricings)),
    //                     totalPrice: formatPrice(OrderQuote.getTotalPrice(item.orderQuotePricings)),
    //                 })}
    //             </span>
    //             <span>{this.tKey('numberOfServiceLines', { nb: item.orderQuotePricings.length.toString() })}</span>
    //             <span>{this.tKey('listOfServiceLines')}</span>
    //             <ul>
    //                 {item.orderQuotePricings.map(quotePricing => (
    //                     <li key={quotePricing.orderQuotePricingId}>
    //                         <b>{quotePricing.orderQuoteService.name}</b>
    //                     </li>
    //                 ))}
    //             </ul>
    //             <div>
    //                 <Label>{`${this.tKey('total')} :`}</Label>
    //                 <span>
    //                     {formatPrice(OrderQuote.getTotal(item.orderQuotePricings))}
    //                 </span>
    //             </div>
    //             <div>
    //                 <Label>{`${this.tKey('totalPrice')} :`}</Label>
    //                 <span>
    //                     {formatPrice(OrderQuote.getTotalPrice(item.orderQuotePricings))}
    //                 </span>
    //             </div>
    //         </div>
    //     )
    // }

    /**
     * Init Page
     */
    init() {
        const {
            setCommand, match, location, orderQuotesHandler, setMessageBar,
        } = this.props

        setMessageBar({ isDisplayed: false })

        // If there is an id in URL, get element by id
        if (match?.params?.orderQuoteId && Number.isInteger(+match.params.orderQuoteId))
            this.setState({ status: Status.PENDING }, async () => {
                if (location.state?.orderQuote) // If object came from history push with a create
                    this.setState({
                        item: location.state?.orderQuote,
                        initItem: location.state?.orderQuote,
                        status: Status.RESOLVED,
                        currentPageIndex: 2,
                    }, () => {
                        this.setupBreadcrumb()
                        this.setupCommandBar()
                    })
                else
                    try {
                        this.orderQuotesHandlerGetById = orderQuotesHandler.getById(match.params.orderQuoteId)
                        const order = await this.orderQuotesHandlerGetById.fetch()
                        this.setState({
                            item: order,
                            initItem: order,
                            currentPageIndex: 2,
                            status: Status.RESOLVED,
                        }, () => {
                            this.setupBreadcrumb()
                            this.setupCommandBar()
                        })
                    } catch (error) {
                        switch (error?.constructor) {
                            case CancelRequestError:
                            case UnauthorizedError:
                            case InvalidEntityError:
                                this.setState({ errorField: /** @type {InvalidEntityError<ErrorOrderQuote>} */(error).errorField })
                                setCommand(this.commandEdit)
                                break
                            case NotImplementedError:
                                // eslint-disable-next-line no-console
                                console.error(error)
                                break
                            default:
                                setCommand(this.commandEdit)
                                this.setState({ status: Status.REJECTED })
                                // eslint-disable-next-line no-console
                                console.error(error)
                                break
                        }
                    }
            })
        else
            this.setState({ status: Status.PENDING }, () => {
                const order = new OrderQuote({
                    merchandises: [new Merchandise({ quantity: 1 })],
                    fileToken: uuidv4(),
                })
                this.setState({
                    item: order,
                    status: Status.IDLE,
                }, () => {
                    this.setupBreadcrumb()
                    this.setupCommandBar()
                })
            })
    }

    /**
     * Function called when valide form in submit, in order to save or create new entity
     */
    upsert() {
        if (!this.isMerchandisesValid()) {
            // eslint-disable-next-line react/destructuring-assignment
            this.props.setMessageBar({
                isDisplayed: true,
                type: MessageBarType.error,
                message: this.tKey('deliveryInvalidFootage'),
            })
            return
        }

        const {
            setCommand, orderQuotesHandler, match, setMessageBar,
        } = this.props

        const { item } = this.state

        this.setState({ status: Status.PENDING, errorField: new ErrorOrderQuote() }, async () => {
            setMessageBar({ isDisplayed: false })
            try {
                const id = match?.params?.orderQuoteId ? +match.params.orderQuoteId : 0
                if (!id)
                    // CRÉATION
                    this.orderQuotesHandlerUpsert = orderQuotesHandler.create(item, item.fileToken)
                else
                    // MISE À JOUR
                    this.orderQuotesHandlerUpsert = orderQuotesHandler.updateById(item, id)

                const orderQuote = await this.orderQuotesHandlerUpsert.fetch()

                setMessageBar({ isDisplayed: false })

                this.setState({
                    item: orderQuote,
                    initItem: orderQuote,
                    status: Status.RESOLVED,
                    currentPageIndex: 2,
                }, () => {
                    this.setupBreadcrumb()
                    this.setupCommandBar()
                })

                if (!(match?.params?.orderQuoteId && Number.isInteger(+match.params.orderQuoteId)))
                    history.replace(`/order-quotes/${orderQuote.orderQuoteId}`)
            } catch (error) {
                this.setState({ status: Status.REJECTED }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError: break
                        case NotImplementedError:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                        case InvalidEntityError:
                            this.setState({ errorField: /** @type {InvalidEntityError<ErrorOrderQuote>} */(error).errorField })
                            setCommand(this.commandEdit)
                            break
                        default:
                            setCommand(this.commandEdit)
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    // eslint-disable-next-line react/no-unused-class-component-methods
    isMerchandisesValid() {
        const { item } = this.state

        for (const m of item.merchandises ?? []) {
            const ml = Number(m.footage ?? 0)
            const long = Number(m.long ?? 0)
            const width = Number(m.width ?? 0)

            const isValid = ml > 0 || (long > 0 && width > 0)

            if (!isValid)
                return false
        }

        return true
    }

    /**
     * Function called when client validate workflow
     * @param {string=} payload payload
     */
    validateOrderQuote(payload) {
        const {
            orderQuotesHandler, setMessageBar,
        } = this.props

        const { item } = this.state

        if (!item?.orderQuoteId)
            return
        this.setState({ status: Status.PENDING }, async () => {
            setMessageBar({ isDisplayed: false })
            try {
                this.orderQuotesHandlerValidate = orderQuotesHandler.validateOrderQuote(item.orderQuoteId, payload)
                setMessageBar({ isDisplayed: false })

                const orderQuote = await this.orderQuotesHandlerValidate.fetch()

                this.setState({
                    item: orderQuote,
                    initItem: orderQuote,
                    status: Status.RESOLVED,
                }, () => {
                    this.setupBreadcrumb()
                    this.setupCommandBar()
                })
            } catch (error) {
                this.setState({ status: Status.REJECTED }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError:
                        case NotImplementedError:
                        default:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            item, status, errorField, currentPageIndex, expirationDate, isExpirationModalVisible,
        } = this.state
        const {
            param, lang, addressesHandler, orderQuotesHandler, editParam, addParam, removeParam,
            setMessageBar, me,
        } = this.props

        if (status === Status.PENDING)
            return <Loader />

        if (!me.company.isOperational)
            return (<MaintenancePortalInfo lang={lang} />)

        const isReadOnly = item.workflowHistorics?.some(x => x.workflowStepId === EWorkflowStep.QuoteRequest && !x.isActive)

        return (
            <main className={styles['id-client']}>
                <form
                    onSubmit={ev => {
                        ev.preventDefault()
                        this.upsert()
                    }}
                >
                    {currentPageIndex === 0 && (
                        <CreationStep
                            lang={lang}
                            item={item}
                            isReadOnly={isReadOnly}
                            errorField={errorField}
                            onChange={newData => this.setState(prevState => ({ item: { ...prevState.item, ...newData } }))}
                            param={param}
                            addressesHandler={addressesHandler}
                            editParam={editParam}
                            addParam={addParam}
                            removeParam={removeParam}
                            me={me}
                        />
                    )}
                    {currentPageIndex === 2 && (
                        <ConfirmationStep
                            lang={lang}
                            item={item}
                            setCurrentPageIndex={newIndex => this.setState({ currentPageIndex: newIndex })}
                            // onChange={newData => this.setState(prevState => ({ item: { ...prevState.item, ...newData } }))}
                            onChange={newData => this.setState(
                                prevState => ({ item: { ...prevState.item, ...newData } }),
                                () => {
                                    this.setupCommandBar()
                                    this.setupBreadcrumb()
                                },
                            )}
                            param={param}
                            orderQuotesHandler={orderQuotesHandler}
                            setMessageBar={setMessageBar}
                            userCanEdit={!isReadOnly}
                            me={me}
                        />
                    )}

                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <button
                        type="submit"
                        style={{ display: 'none' }}
                        ref={this.submitInput}
                        tabIndex={-1}
                    />
                </form>
                <ConfirmationModal
                    isVisible={isExpirationModalVisible}
                    setIsVisible={val => this.setState({ isExpirationModalVisible: val })}
                    initialDate={expirationDate}
                    item={item}
                    lang={lang}
                    onConfirm={date => {
                        this.setState(
                            { expirationDate: date, isExpirationModalVisible: false },
                            () => {
                                this.validateOrderQuote({
                                    isValidated: true,
                                    expirationDate: date ? date.toISOString() : null,
                                })
                            },
                        )
                    }}
                />
            </main>
        )
    }
}

IdClientOrderQuotes.prototype.tKey = tKey
IdClientOrderQuotes.prototype.tObj = tObj
IdClientOrderQuotes.prototype.parseJson = parseJson
